import React, { useEffect, useState } from "react";

import logo from "src/assets/images/ubs-logo.png";

/* =====================================================
   GLOBAL EVENT
===================================================== */

let showModal = () => {};

let isSessionModalOpen = false;

export const showSessionExpiredModal = () => {
  if (isSessionModalOpen) return;

  isSessionModalOpen = true;  
  showModal();  
};

export const resetSessionExpiredModal = () => {
  isSessionModalOpen = false;
};

/* =====================================================
   COMPONENT
===================================================== */

const SessionExpiredModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    showModal = () => {
      if (!isSessionModalOpen) return;

      setOpen(true);
    };

    return () => {
      showModal = () => {};
    };
  }, []);

  if (!open) return null;

  const handleContinue = () => {
    // Reset modal state
    resetSessionExpiredModal();

    // Close modal
    setOpen(false);

    // Clear all application data
    localStorage.clear();
    sessionStorage.clear();

    // Remove browser history entry
    window.history.replaceState(null, "", "/portal");

    // Force complete application reload
    window.location.replace("/portal");
  };

  return (
    <div
      className="
        fixed
        inset-0
        z-[999999]
        flex
        items-center
        justify-center
        bg-black/35
        backdrop-blur-[5px]
      "
    >
      <div
        className="
          w-[520px]
          overflow-hidden
          rounded-[22px]
          bg-white
          shadow-[0_30px_90px_rgba(0,0,0,.30)]
          animate-[fadeIn_.25s_ease]
        "
      >
        <style>
          {`
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: scale(.96);
              }
              to {
                opacity: 1;
                transform: scale(1);
              }
            }
          `}
        </style>

        {/* Top Accent */}
        <div className="h-[4px] bg-[#d40511]" />

        {/* Body */}
        <div className="px-10 py-9">
          <div className="flex justify-center">
            <img
              src={logo}
              alt="UBS"
              className="w-[78px]"
            />
          </div>

          <h2
            className="
              mt-7
              text-center
              text-[30px]
              font-light
              text-[#1f1f1f]
            "
          >
            Session expired
          </h2>

          <p
            className="
              mt-5
              text-center
              text-[15px]
              leading-7
              text-[#666]
            "
          >
            Your session has expired.
            <br />
            Please log in again to continue using UBS E-Banking.
          </p>

          <div className="mt-9 flex justify-center">
            <button
              onClick={handleContinue}
              className="
                h-[44px]
                min-w-[180px]
                rounded-full
                bg-[#d40511]
                text-white
                text-[15px]
                font-medium
                hover:bg-[#b3000d]
                transition-all
                duration-200
                shadow-[0_12px_30px_rgba(212,5,17,.28)]
              "
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;